/**
 * Prevents the second call (bound by click), going out after a user presses
 * Enter. Returned handler invokes the passed function and passes event data.
 */
const createBtnLinkKeyDownHandler = clickHandler => ev => {
  switch (ev.which) {
    case 13: // ENTER
      clickHandler(ev);
      break;

    case 32: // SPACE
      ev.nativeEvent.preventDefault(); // Prevent scroll when using space bar.
      clickHandler(ev);
      break;

    default:
      break;
  }
};

export default createBtnLinkKeyDownHandler;
